import GifObject from '@/docs-partials/api/schema/gif-object.mdx';
import * as React from 'react';
export default {
  GifObject,
  React
};